import RelativeHumiditySensorIcon from '!!raw-loader!./assets/dashboard/svg/noun_humidity_1001987.svg';
import TemperatureHotSensorIcon from '!!raw-loader!./assets/dashboard/svg/noun_Thermometer_3697915.svg';
import TemperatureColdSensorIcon from '!!raw-loader!./assets/dashboard/svg/noun_Thermometer_3697916.svg';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomSanitizer } from '@angular/platform-browser';
import { AdvancedDropdownModule } from '@captiveaire/advanceddropdown';
import { TableModule } from '@captiveaire/table';
import { AppModule as WeeklySchedulerModule } from '@captiveaire/weeklyscheduler';
import { AreaMenuModule } from '@caslink/common-client/ng-app/area-menu/area-menu.module';
import { FormsModule as CasFormsModule } from '@caslink/common-client/ng-app/forms/FormsModule';
import { AngularUpgradeHelper } from '@caslink/common-client/ng-app/helpers/AngularUpgradeHelper';
import { LoadingAnimationModule } from '@caslink/common-client/ng-app/loadingAnimation/LoadingAnimationModule';
import { AppModule as CasCommonAppModule } from '@caslink/common-client/ng-app/module';
import { AreaMenuIconModule } from '@caslink/common-client/ng-app/areaMenuIcon/AreaMenuIconModule';
import { NotificationService } from '@caslink/common-client/ng-app/notification/NotificationService';
import { SideFiltersModule } from '@caslink/common-client/ng-app/side-filters/side-filters.module';
import { UIRouterModule } from '@uirouter/angular';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';
import { DateFormatPipe, MomentModule, UtcPipe } from 'ngx-moment';
import {
    AuditHistoryConfirmedCellComponent,
} from './audit-history-confirmed-cell/audit-history-confirmed-cell.component';
import { AuditingComponent } from './auditing/auditing.component';
import { AuditingRouteComponent } from './auditing-route/auditing-route.component';
import { AuditingService } from './auditing/auditing.service';
import { ControlSettingTemplatesService } from './shared/services/control-setting-templates.service';
import { AuditHistoryComponent } from './audit-history/audit-history.component';
import { AuditNoteExpandRowComponent } from './audit-note-expand-row/audit-note-expand-row.component';
import { CardBackgroundUpdateService } from './card/card-background-update.service';
import { CardComponent } from './card/card.component';
import { CardDisplayInfoComponent } from './card-display-info/card-display-info.component';
import { CardListItemClickService } from './card-list-item/card-list-item-click.service';
import { CardListItemComponent } from './card-list-item/card-list-item.component';
import { ControlComponent } from './control/control.component';
import { ControlRouteComponent } from './control-router/control-route.component';
import { DeviceSettingsBaseComponent } from './device-settings-base/device-settings-base.component';
import { CurrentInfoComponent } from './current-info/current-info.component';
import { CurrentInfoRouteComponent } from './current-info-route/current-info-route.component';
import { DynamicSlotEditorComponent } from './dynamic-slot-editor/dynamic-slot-editor.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { ScheduleRouteComponent } from './schedule-route/schedule-route.component';
import { SystemSettingsComponent } from './system-settings/system-settings.component';
import { SystemSettingsRouteComponent } from './system-settings-route/system-settings-route.component';
import { ControlService } from './control/control.service';
import { CopyToComponent } from './copy-to/copy-to.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardDeviceComponent } from './dashboard-device/dashboard-device.component';
import { DashboardViewService } from './shared/services/dashboard-view.service';
import { DeviceService } from './shared/services/device.service';
import { DeviceBulkOperationComponent } from './device-bulk-operation/device-bulk-operation.component';
import { DeviceFirmwareUpdateBulkComponent } from './device-firmware-update-bulk/device-firmware-update-bulk.component';
import { DeviceInputModule } from './device-input/device-input.module';
import { DeviceMenuItemsService } from './shared/services/device-menu-items.service';
import { DeviceModelFactoryService } from './shared/services/device-model-factory.service';
import { DeviceModelService } from './shared/services/device-model.service';
import { DynamicDeviceModelService } from './device-model/dynamic-device-model.service';
import { DeviceReaderStatusComponent } from './device-reader-status/device-reader-status.component';
import { DeviceRecommendedActionComponent } from './device-recommended-action/device-recommended-action.component';
import { DeviceStatusService } from './shared/services/device-status.service';
import { DeviceStatusBarComponent } from './device-status-bar/device-status-bar.component';
import { DeviceStatusCellComponent } from './device-status-cell/device-status-cell.component';
import { DeviceStatusTableCellComponent } from './device-status-table-cell/device-status-table-cell.component';
import {
    DeviceStatusConfigurationCellComponent,
} from './device-status-configuration-cell/device-status-configuration-cell.component';
import { DeviceStatusExpandRowComponent } from './device-status-expand-row/device-status-expand-row.component';
import {
    DeviceStatusFirmwareVersionCellComponent,
} from './device-status-firmware-version-cell/device-status-firmware-version-cell.component';
import { DeviceStatusGridComponent } from './device-status-grid/device-status-grid.component';
import { DeviceStatusMacCellComponent } from './device-status-mac-cell/device-status-mac-cell.component';
import {
    DeviceStatusModbusIdCellComponent,
} from './device-status-modbus-id-cell/device-status-modbus-id-cell.component';
import { DeviceStatusVersionCellComponent } from './device-status-version-cell/device-status-version-cell.component';
import { DeviceStatusViewInfoQueryService } from './shared/services/device-status-view-info-query.service';
import { DeviceStatusViewInfoService } from './shared/services/device-status-view-info.service';
import { DisplayInfoIconComponent } from './display-info-icon/display-info-icon.component';
import { DynamicComponentService } from './device-input/dynamic-component.service';
import {
    CurrentInfoChangeConfirmationComponent,
} from './current-info-change-confirmation/current-info-change-confirmation.component';
import {
    DynamicScheduleChangeConfirmationComponent,
} from './dynamic-schedule-change-confirmation/dynamic-schedule-change-confirmation.component';
import { DeviceChangeConfirmationComponent } from './device-change-confirmation/device-change-confirmation.component';
import { FirmwareVersionService } from './shared/services/firmware-version.service';
import { GaugeComponent } from './gauge/gauge.component';
import { GraphicBehaviorComponent } from './graphic-behavior/graphic-behavior.component';
import {
    HardwareItemSyncLoadingAnimationModule,
} from './hardware-item-sync-loading-animation/hardware-item-sync-loading-animation.module';
import { InputMapService } from './shared/services/input-map.service';
import { OverrideZoneComponent } from './override-zone/override-zone.component';
import { ReportTemplateService } from './shared/services/report-template.service';
import { RtuCurrentInfoService } from './rtu-setpoint-editor/rtu-current-info.service';
import { RtuSchedulerSlotEditorComponent } from './rtu-scheduler-slot-editor/rtu-scheduler-slot-editor.component';
import { RtuStaticScheduleComponent } from './rtu-static-schedule/rtu-static-schedule.component';
import { RtuStaticScheduleService } from './shared/services/rtu-static-schedule.service';
import { RtuSetpointEditorModule } from './rtu-setpoint-editor/rtu-setpoint-editor.module';
import { SensorCategoryTypeService } from './shared/services/sensor-category-type.service';
import { SetpointComponent } from './setpoint/setpoint.component';
import { DynamicControlsSharedStateService } from './shared/services/dynamic-controls-shared-state.service';
import { StaticScheduleRouteComponent } from './static-schedule-route/static-schedule-route.component';
import { TemplateChoiceDialogComponent } from './template-choice-dialog/template-choice-dialog.component';
import { UpdateConfirmationDialogComponent } from './update-confirmation-dialog/update-confirmation-dialog.component';
import { TemplateNameDialogComponent } from './template-name-dialog/template-name-dialog.component';
import { CaalFileDialogComponent } from './caal-file-dialog/caal-file-dialog.component';
import { AuditHistoryDialogComponent } from './audit-history-dialog/audit-history-dialog.component';
import { ControlsAreaModule } from './controls-area/controls-area.module';
import { SubToolbarModule } from '@caslink/common-client/ng-app/sub-toolbar/sub-toolbar.module';
import { DashboardAreaComponent } from './dashboard-area/dashboard-area.component';
import { QrDashboardAreaComponent } from './qr-dashboard-area/qr-dashboard-area.component';
import { DeviceDetailFiltersComponent } from './device-detail-filters/device-detail-filters.component';
import { DeviceDetailFiltersService } from './device-detail-filters/device-detail-filters.service';
import {
    DeviceStatusPendingVersionCellComponent,
} from './device-status-pending-version-cell/device-status-pending-version-cell.component';
import { DeviceStatusListAreaComponent } from './device-status-list-area/device-status-list-area.component';
import { DeviceSearchComponent } from './device-search/device-search.component';
import { NavToolbarModule } from '@caslink/common-client/ng-app/nav-toolbar/nav-toolbar.module';
import { DeviceCardControlsComponent } from './device-card-controls/device-card-controls.component';
import { DeviceJsonViewerComponent } from './device-json-viewer/device-json-viewer.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { DeviceCardComponent } from './device-card/device-card.component';
import { ModuleCardComponent } from './module-card/module-card.component';
import { HeightWatcherDirective } from './module-card/height-watcher.directive';
import { DeviceDetailViewComponent } from './device-detail-view/device-detail-view.component';
import { CdkTreeModule } from '@angular/cdk/tree';
import { MatTreeModule } from '@angular/material/tree';
import { GraphicBehaviorType } from './shared/models/graphic-behavior-type.enum';
import { NolaJobDocumentComponent } from './nola-job-document/nola-job-document.component';
import { FolderNameDialogComponent } from './folder-name-dialog/folder-name-dialog.component';
import { TreeViewCellModule } from './tree-view-cell/tree-view-cell.module';
import { TreeViewCellService } from './tree-view-cell/tree-view-cell.service';
import { ResizableMapModule } from '@caslink/common-client/ng-app/resizableMap/resizable-map.module';
import {
    ControlSettingTemplatesTreeViewCellComponent,
} from './control-setting-templates-tree-view-cell/control-setting-templates-tree-view-cell.component';
import { NestSliderComponent } from '@caslink/device-client/ng-app/nest-slider/nest-slider.component';
import { CircularSliderModule } from '@caslink/device-client/ng-app/circular-slider/circular-slider.module';
import { SemiCircleComponent } from '@caslink/device-client/ng-app/semi-circle/semi-circle.component';
import { CipherSemiCircleComponent } from '@caslink/device-client/ng-app/semi-circle/cipher-semi-circle.component';
import { CoolingSemiCircleComponent } from '@caslink/device-client/ng-app/semi-circle/cooling-semi-circle.component';
import { HeatingSemiCircleComponent } from '@caslink/device-client/ng-app/semi-circle/heating-semi-circle.component';
import {
    CardNestSliderWrapperComponent,
} from '@caslink/device-client/ng-app/card-nest-slider-wrapper/card-nest-slider-wrapper.component';
import { DashboardToastrConfirmationService } from './shared/services/dashboard-toastr-confirmation.service';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { SharedPipesModule } from '@caslink/device-client/ng-app/shared/pipes/shared-pipes.module';

@NgModule({
    imports: [
        AdvancedDropdownModule,
        CasCommonAppModule,
        CasFormsModule,
        CommonModule,
        DeviceInputModule,
        FlexLayoutModule,
        LoadingAnimationModule,
        MatButtonModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatCardModule,
        MatDialogModule,
        MatIconModule,
        MatInputModule,
        MatRadioModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatTabsModule,
        MatTooltipModule,
        MomentModule,
        ReactiveFormsModule,
        FormsModule,
        RtuSetpointEditorModule,
        TableModule,
        UIRouterUpgradeModule.forRoot(),
        WeeklySchedulerModule,
        MatListModule,
        MatMenuModule,
        UIRouterModule,
        HardwareItemSyncLoadingAnimationModule,
        AreaMenuModule,
        ControlsAreaModule,
        SubToolbarModule,
        AreaMenuIconModule,
        NavToolbarModule,
        NgxJsonViewerModule,
        SideFiltersModule,
        MatDividerModule,
        CdkTreeModule,
        MatTreeModule,
        TreeViewCellModule,
        ResizableMapModule,
        CircularSliderModule,
        MatTreeModule,
        CircularSliderModule,
        MatButtonToggleModule,
        SharedPipesModule,
    ],
    declarations: [
        AuditingComponent,

        AuditingRouteComponent,
        ControlRouteComponent,
        ScheduleRouteComponent,
        CurrentInfoRouteComponent,
        StaticScheduleRouteComponent,
        SystemSettingsRouteComponent,

        ControlComponent,
        SetpointComponent,

        CurrentInfoComponent,
        CurrentInfoChangeConfirmationComponent,
        OverrideZoneComponent,

        ScheduleComponent,
        DynamicScheduleChangeConfirmationComponent,
        DynamicSlotEditorComponent,
        RtuSchedulerSlotEditorComponent,
        RtuStaticScheduleComponent,
        CopyToComponent,
        DeviceStatusBarComponent,

        SystemSettingsComponent,
        DeviceChangeConfirmationComponent,

        AuditHistoryComponent,
        AuditNoteExpandRowComponent,

        CardComponent,
        CardDisplayInfoComponent,
        CardListItemComponent,
        DisplayInfoIconComponent,
        GaugeComponent,
        GraphicBehaviorComponent,

        AuditHistoryConfirmedCellComponent,
        TemplateNameDialogComponent,
        CaalFileDialogComponent,
        AuditHistoryDialogComponent,
        TemplateChoiceDialogComponent,
        UpdateConfirmationDialogComponent,
        DeviceBulkOperationComponent,
        DeviceFirmwareUpdateBulkComponent,
        DeviceStatusGridComponent,
        DeviceStatusCellComponent,
        DeviceStatusTableCellComponent,
        DeviceRecommendedActionComponent,
        DeviceStatusConfigurationCellComponent,
        DeviceStatusExpandRowComponent,
        DeviceStatusMacCellComponent,
        DeviceStatusModbusIdCellComponent,
        DeviceStatusFirmwareVersionCellComponent,
        DeviceReaderStatusComponent,
        DeviceStatusVersionCellComponent,
        DashboardDeviceComponent,
        DashboardComponent,
        DeviceSettingsBaseComponent,
        DashboardAreaComponent,
        QrDashboardAreaComponent,
        DeviceDetailFiltersComponent,
        DeviceStatusPendingVersionCellComponent,
        DeviceStatusListAreaComponent,
        DeviceSearchComponent,
        DeviceCardControlsComponent,
        DeviceJsonViewerComponent,
        DeviceCardComponent,
        ModuleCardComponent,
        HeightWatcherDirective,
        DeviceDetailViewComponent,
        NolaJobDocumentComponent,
        FolderNameDialogComponent,
        ControlSettingTemplatesTreeViewCellComponent,
        NestSliderComponent,
        SemiCircleComponent,
        CipherSemiCircleComponent,
        CoolingSemiCircleComponent,
        HeatingSemiCircleComponent,
        CardNestSliderWrapperComponent,
    ],
    entryComponents: [
        AuditingRouteComponent,
        ControlRouteComponent,
        ScheduleRouteComponent,
        CurrentInfoRouteComponent,
        DashboardComponent,
        StaticScheduleRouteComponent,
        SystemSettingsRouteComponent,

        ControlComponent,
        SetpointComponent,

        CurrentInfoComponent,
        CurrentInfoChangeConfirmationComponent,
        OverrideZoneComponent,

        ScheduleComponent,
        DynamicScheduleChangeConfirmationComponent,
        DynamicSlotEditorComponent,
        RtuSchedulerSlotEditorComponent,
        RtuStaticScheduleComponent,
        CopyToComponent,
        DeviceStatusBarComponent,

        SystemSettingsComponent,
        DeviceChangeConfirmationComponent,

        AuditHistoryComponent,
        AuditNoteExpandRowComponent,

        CardComponent,
        CardDisplayInfoComponent,
        CardListItemComponent,
        DisplayInfoIconComponent,
        GaugeComponent,
        GraphicBehaviorComponent,

        AuditHistoryConfirmedCellComponent,
        TemplateNameDialogComponent,
        CaalFileDialogComponent,
        AuditHistoryDialogComponent,
        TemplateChoiceDialogComponent,
        UpdateConfirmationDialogComponent,
        DeviceBulkOperationComponent,
        DeviceFirmwareUpdateBulkComponent,
        DeviceStatusCellComponent,
        DeviceStatusTableCellComponent,
        DeviceStatusGridComponent,
        DeviceRecommendedActionComponent,
        DeviceStatusConfigurationCellComponent,
        DeviceStatusExpandRowComponent,
        DeviceStatusMacCellComponent,
        DeviceStatusModbusIdCellComponent,
        DeviceStatusFirmwareVersionCellComponent,
        DeviceReaderStatusComponent,
        DeviceStatusVersionCellComponent,
        DashboardDeviceComponent,
        DashboardAreaComponent,
        QrDashboardAreaComponent,
        DeviceDetailFiltersComponent,
        DeviceStatusPendingVersionCellComponent,
        DeviceStatusListAreaComponent,
        DeviceSearchComponent,
        DeviceCardControlsComponent,
        DeviceJsonViewerComponent,
        DeviceCardComponent,
        ModuleCardComponent,
        DeviceDetailViewComponent,
        NolaJobDocumentComponent,
        FolderNameDialogComponent,
        ControlSettingTemplatesTreeViewCellComponent,
    ],
    exports: [
        CardDisplayInfoComponent,
        CardListItemComponent,
        ControlRouteComponent,
        DashboardComponent,
        ScheduleRouteComponent,
        AuditHistoryConfirmedCellComponent,
        TemplateNameDialogComponent,
        CaalFileDialogComponent,
        AuditHistoryDialogComponent,
        TemplateChoiceDialogComponent,
        UpdateConfirmationDialogComponent,
        DeviceStatusTableCellComponent,
        DeviceRecommendedActionComponent,
        DeviceStatusConfigurationCellComponent,
        DeviceStatusMacCellComponent,
        DeviceStatusModbusIdCellComponent,
        DeviceStatusFirmwareVersionCellComponent,
        DisplayInfoIconComponent,
        GaugeComponent,
        DashboardAreaComponent,
        QrDashboardAreaComponent,
        DeviceDetailFiltersComponent,
        DeviceStatusPendingVersionCellComponent,
        DeviceStatusListAreaComponent,
        DeviceSearchComponent,
        DeviceCardControlsComponent,
        DeviceJsonViewerComponent,
        DeviceCardComponent,
        ModuleCardComponent,
        HeightWatcherDirective,
        DeviceDetailViewComponent,
        NolaJobDocumentComponent,
        FolderNameDialogComponent,
        ControlSettingTemplatesTreeViewCellComponent,
    ],
    providers: [
        DateFormatPipe,
        UtcPipe,

        DashboardViewService,
        DynamicComponentService,

        ControlService,
        DeviceModelService,
        DeviceService,
        InputMapService,
        DynamicControlsSharedStateService,
        FirmwareVersionService,

        RtuCurrentInfoService,
        RtuStaticScheduleService,

        CardBackgroundUpdateService,
        DynamicDeviceModelService,
        CardListItemClickService,
        DashboardToastrConfirmationService,
    ],
})
export class AppModule {
    private deviceModuleName = 'app.areas.devices';

    constructor(
        private iconRegistry: MatIconRegistry,
        private sanitizer: DomSanitizer,
    ) {
        this.registerComponents();
        this.registerServices();
        this.registerIcons();
    }

    private registerComponents() {
        AngularUpgradeHelper.downgradeComponents(this.deviceModuleName, [
            CardComponent,
            CardDisplayInfoComponent,
            ControlComponent,
            CurrentInfoComponent,
            DeviceReaderStatusComponent,
            DeviceStatusGridComponent,
            DeviceStatusCellComponent,
            RtuStaticScheduleComponent,
            SetpointComponent,
            SystemSettingsComponent,
            DeviceStatusFirmwareVersionCellComponent,
            DeviceStatusVersionCellComponent,
            DeviceStatusConfigurationCellComponent,
            DeviceStatusModbusIdCellComponent,
            DashboardComponent,
            DashboardDeviceComponent,
            DeviceDetailFiltersComponent,
            DeviceStatusPendingVersionCellComponent,
            DeviceSearchComponent,
            DeviceCardControlsComponent,
            DeviceJsonViewerComponent,
            DeviceCardComponent,
            ModuleCardComponent,
            DeviceDetailViewComponent,
            NolaJobDocumentComponent,
        ]);
    }

    private registerServices() {
        let services = [
            AuditingService,
            ControlSettingTemplatesService,
            ControlService,
            DashboardViewService,
            DeviceMenuItemsService,
            DeviceService,
            DeviceStatusService,
            DeviceStatusViewInfoService,
            DeviceStatusViewInfoQueryService,
            DeviceModelFactoryService,
            DeviceModelService,
            FirmwareVersionService,
            InputMapService,
            DynamicControlsSharedStateService,
            RtuCurrentInfoService,
            RtuStaticScheduleService,
            SensorCategoryTypeService,
            ReportTemplateService,
            NotificationService,
            CardBackgroundUpdateService,
            DynamicDeviceModelService,
            CardListItemClickService,
            DeviceDetailFiltersService,
            TreeViewCellService,
        ];

        AngularUpgradeHelper.downgradeServices(this.deviceModuleName, services);
    }

    private registerIcons() {
        const icons = [
            {
                name: GraphicBehaviorType.RELATIVE_HUMIDITY_SENSOR,
                svg: RelativeHumiditySensorIcon,
            },
            {
                name: GraphicBehaviorType.TEMPERATURE_HOT_SENSOR,
                svg: TemperatureHotSensorIcon,
            },
            {
                name: GraphicBehaviorType.TEMPERATURE_HOT_UNOCCUPIED_SENSOR,
                svg: TemperatureHotSensorIcon,
            },
            {
                name: GraphicBehaviorType.TEMPERATURE_COLD_SENSOR,
                svg: TemperatureColdSensorIcon,
            },
            {
                name: GraphicBehaviorType.TEMPERATURE_COLD_UNOCCUPIED_SENSOR,
                svg: TemperatureColdSensorIcon,
            },
        ];

        icons.forEach(icon => {
            this.iconRegistry.addSvgIconLiteral(icon.name, this.sanitizer.bypassSecurityTrustHtml(icon.svg));
        });
    }
}
